var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"navTo"},[_c('router-link',{attrs:{"to":_vm.link}},[_c('span',[_vm._v("\n      "+_vm._s(_vm.title)+"\n      "),_c('img',{attrs:{"src":"/static/v2/match/view_all_tri.png"}})])])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ba71fdc","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v2/NavTo.vue
// module id = null
// module chunks = 